// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { GroupExceptionUserMenu } from './group-exception-user-menu'

const COMPONENT = 'groupExceptionUserMenu'

interface Prop {
  roomId: string
  userId: string
}

export const showGroupExceptionUserMenu = (
  props: Prop,
  preventBackClick = false,
) => addModal({ id: COMPONENT, props, preventBackClick })

export default {
  [COMPONENT]: { Component: GroupExceptionUserMenu },
}
